import { render, staticRenderFns } from "./DropdownInputElement.vue?vue&type=template&id=0a896d96&scoped=true&"
import script from "./DropdownInputElement.vue?vue&type=script&lang=ts&"
export * from "./DropdownInputElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a896d96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/app-root/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a896d96')) {
      api.createRecord('0a896d96', component.options)
    } else {
      api.reload('0a896d96', component.options)
    }
    module.hot.accept("./DropdownInputElement.vue?vue&type=template&id=0a896d96&scoped=true&", function () {
      api.rerender('0a896d96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/GPortal/Frontend/vue/component/ui/form/elements/DropdownInputElement.vue"
export default component.exports